import angular from "angular";
import Vue from "vue";
import "ngVue";

import InstructorServiceAreaMap from "./InstructorServiceAreaMap.vue";

export default angular
  .module("directives.instructorServiceAreaMap", [])
  .directive("instructorServiceAreaMap", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(
        Vue.component("InstructorServiceAreaMap", InstructorServiceAreaMap),
      );
    },
  ]);
